// Shared counting for rich-text (Quill) values.
//
// A naive `replace(/<[^>]+>/g, ' ')` splits a word wherever an inline tag sits,
// so `is <strong>+971</strong>.` counts as "is", "+971", "." — three words for
// two. Block-level tags DO separate words; inline ones never do. Keeping this in
// one place is what makes the editor's live counter and the Yup rule agree.

const BLOCK_BREAK = /<\/(?:p|div|li|h[1-6]|blockquote|pre|tr)>|<br\s*\/?>/gi;

export const richTextToPlainText = (html) => {
  const withBreaks = String(html ?? '').replace(BLOCK_BREAK, '\n');
  const withoutTags = withBreaks.replace(/<[^>]+>/g, '');
  // Decode entities (&nbsp;, &amp;, …) the way the editor renders them.
  const decoder = document.createElement('textarea');
  decoder.innerHTML = withoutTags;
  return decoder.value;
};

export const countRichTextWords = (html) =>
  richTextToPlainText(html).trim().split(/\s+/).filter(Boolean).length;

export const countRichTextCharacters = (html) =>
  richTextToPlainText(html).replace(/\s+/g, '').length;
